export default ({ title, localName, year }) => ({ num = '-', font = 'base' }) => ({
    font,
    titles: {
        markdown: true,
        text: `**${title}** | ${localName} LGA - ${year}`
    },
    pageNum: {
        text: `${num}`,
        align: 'right',
        position: 'absolute'
    }
});
